/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

// ? This script will deal with the user queries for showing and filtering events.

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
// *=====================================================================================* //

export const events = () => {
    let body = document.querySelector("body");

    let eventContainer = document.querySelector(".event_listing-wrapper");
    if (eventContainer) {
        // == Declare filters == //
        // = City ID = //
        // Check if we are on a single city to add it to the request
        let cityId = "";
        let singleCity = document.querySelector("[data-single-city]");
        if (singleCity) {
            cityId = singleCity.getAttribute("data-single-city");
        }

        // = Event kind = //
        let kind = "";

        // = Manual search = //
        let search = "";

        // ** === EVENT POPUP === ** //
        let popup = document.querySelector("[data-event-popup]");

        // * == Function to show and fill the popup * = //
        const showPopup = (e) => {
            let card = e.currentTarget;

            // == A) Transfer data in popup
            // Event kind
            let banner = popup.querySelector(".event-details_banner");
            let formerKind = banner.getAttribute("data-event-kind");
            let newKind = card.getAttribute("data-event-kind");
            banner.classList.remove(formerKind);
            banner.classList.add(newKind);
            banner.setAttribute("data-event-kind", newKind);

            // Icon
            popup.querySelector(".event-details_icon").innerHTML = card.querySelector(".event-card_icon").innerHTML;

            // Date
            popup.querySelector(".event-details_date").textContent = card.querySelector(".event-card_date").textContent;

            // City
            popup.querySelector(".event-details_city").textContent = card.querySelector(".event-card_city-name").textContent;

            // Type + hours
            popup.querySelector(".event-details_time").textContent = card.querySelector(".event-card_schedule").textContent;

            // Price
            popup.querySelector(".event-details_price").textContent = card.querySelector("[data-event-price]").textContent;

            // Details
            let richtext = card.querySelector("[data-event-details]").innerHTML;
            let richTextContainer = popup.querySelector(".event-details-rt");
            if (richtext) {
                richTextContainer.parentElement.style.display = "block";
                richTextContainer.innerHTML = richtext;
            } else {
                richTextContainer.parentElement.style.display = "none";
            }

            // Address
            popup.querySelector("[data-event-salle]").textContent = card.querySelector(".event-card_location").textContent;
            popup.querySelector("[data-event-address]").textContent = card.querySelector("[data-event-address]").textContent;

            // == B) Pan the map to the location
            let markerId = card.getAttribute("data-event-salle-id");
            let mapContainer = popup.querySelector(".gm-map");

            if (markerId) {
                mapContainer.style.display = "block";
                mapContainer.style.overflow = "hidden";
                map = googleMaps.getMap("winslow-popup-map");
                map.panToMarker(markerId + "-location")
                    .zoom(15)
                    .refresh();
            } else {
                mapContainer.style.display = "none";
            }

            // == C) Finally, show popup
            e.preventDefault();
            e.stopPropagation();
            popup.classList.add("active");
            body.style.overflow = "hidden";
        };

        // * == Function to hide the popup * = //
        const hidePopup = () => {
            if (popup) {
                if (popup.classList.contains("active")) {
                    popup.classList.remove("active");
                    body.style.overflowY = "visible";
                }
            }
        };

        // * == Function to attach the popup listener on every event cards == * //
        const attachPopup = () => {
            if (popup) {
                let eventCards = eventContainer.querySelectorAll(".event_card");
                if (eventCards.length > 0) {
                    for (let currentCard of eventCards) {
                        currentCard.addEventListener("click", showPopup);
                    }
                }
            }
        };

        // * == Function to detach the listener from the event cards, as they are being removed by a new search == * //
        const detachPopup = () => {
            if (popup) {
                let eventCards = eventContainer.querySelectorAll(".event_card");
                if (eventCards.length > 0) {
                    for (let currentCard of eventCards) {
                        currentCard.removeEventListener("click", showPopup);
                    }
                }
            }
        };

        // * = Popup removal listeners = * //
        if (popup) {
            // Clicks to remove the popup
            document.addEventListener("click", hidePopup);
            document.querySelector(".event-details_close").addEventListener("click", hidePopup);

            // .. so don't propagate anything if we click on it
            popup.querySelector(".event-details_wrapper").addEventListener("click", (e) => e.stopPropagation());
        }

        // ** == AJAX search function == ** //
        async function searchEvents() {
            // Let's get the current state of search filter before actually searching
            data = "?";
            if (cityId !== "") {
                data += "&city=" + cityId;
            }
            if (kind !== "") {
                data += "&kind=" + kind;
            }
            if (search !== "") {
                data += "&search=" + search;
            }

            try {
                const response = await fetch("/ajax/events-search" + data);
                if (!response.ok) {
                    throw new Error("HTTP error! Status: " + response.status);
                }
                const htmlContent = await response.text();
                detachPopup();
                eventContainer.innerHTML = htmlContent;
                showLoadMore();
                attachPopup();
            } catch (error) {
                console.error("An error occurred:", error);
                eventContainer.innerHTML = "An error occurred while fetching the events data.";
            }
        }

        // * == Reset loadMore button function * ==
        // This function is called on load and after each refresh. It detects whether the result contains too many events.
        // If so, it shows the "Load more" button, and detects a click on it to unhide hidden events.
        let showLoadMore = () => {
            let hiddenEvents = document.querySelectorAll("[data-overloaded]");
            if (hiddenEvents.length > 0) {
                let loadMoreBtn = document.querySelector(".show-more-wrapper");
                let loadMoreBtnTxt = loadMoreBtn.querySelector("[data-load-more-text]");
                let component = document.querySelector(".event_component");

                // Show the loadMore button
                loadMoreBtn.style.display = "flex";

                let componentExtendedHeight = component.offsetHeight; // Wemember the max height for a cute twansition

                for (let currentEvent of hiddenEvents) {
                    // Hide the events
                    currentEvent.style.display = "none";
                }

                let componentSmallerHeight = component.offsetHeight; // Wemember the min height for a cute twansition

                loadMoreBtn.addEventListener("click", (e) => {
                    e.preventDefault();

                    // 1) Detect if we are requested to show or hide the events
                    let state = hiddenEvents[0].getAttribute("data-overloaded");

                    // 2) If hidden, we wanna see them!
                    if (state === "hidden") {
                        // Show the events
                        hiddenEvents.forEach((event) => {
                            event.style.display = "block";
                            event.setAttribute("data-overloaded", "visible");
                        });

                        // Transition
                        component.style.height = componentSmallerHeight + "px";
                        gsap.to(component, {
                            duration: 1,
                            height: componentExtendedHeight,
                            onComplete: () => (component.style.height = "auto"),
                        });

                        // Change the btn text
                        loadMoreBtnTxt.textContent = "Afficher moins";
                    }

                    // 3) If visible, we wanna hide them!
                    if (state === "visible") {
                        // Hide the events
                        hiddenEvents.forEach((event) => {
                            event.style.display = "none";
                            event.setAttribute("data-overloaded", "hidden");
                        });

                        // Transition
                        component.style.height = componentExtendedHeight + "px";
                        gsap.to(component, {
                            duration: 1,
                            height: componentSmallerHeight,
                            onComplete: () => (component.style.height = "auto"),
                        });

                        // Climb back to the top of the component
                        gsap.to(window, {
                            duration: 0.75,
                            scrollTo: {
                                y: ".event_component",
                                offsetY: 150,
                            },
                        });

                        // Change the btn text
                        loadMoreBtnTxt.textContent = "Afficher plus";
                    }
                });
            }
        };

        // * O) Initial load and filter reset

        window.addEventListener("DOMContentLoaded", searchEvents());

        let reset = document.querySelector("[data-reset]");
        let eventSearch = document.querySelector("[data-event-search]");
        let dropdownKind = document.querySelector("[data-kinds-dropdown]");
        let dropdownKindContent = dropdownKind.innerHTML;
        let dropdownCity = document.querySelector("[data-cities-dropdown]");
        let dropdownCityContent = dropdownCity ? dropdownCity.innerHTML : "";

        reset.addEventListener("click", (e) => {
            e.preventDefault();
            e.currentTarget.style.display = "none";
            eventSearch.value = "";
            dropdownKind.innerHTML = dropdownKindContent;
            if (dropdownCity) {
                dropdownCity.innerHTML = dropdownCityContent;
                cityId = "";
            }
            kind = "";
            search = "";
            searchEvents();
        });

        // * A) Manual search
        if (eventSearch) {
            let call;

            eventSearch.addEventListener("input", (e) => {
                clearTimeout(call);
                let data = e.currentTarget.value;

                if (data === "") {
                    search = "";
                    searchEvents();
                } else if (data.length >= 3) {
                    call = setTimeout(() => {
                        search = data;
                        searchEvents();
                    }, 666);
                }
            });
        }

        // * B) Event search by kind
        let kindFilters = document.querySelectorAll("[data-kind]");
        if (kindFilters.length > 0) {
            for (let currentKind of kindFilters) {
                currentKind.addEventListener("click", (e) => {
                    e.preventDefault();
                    kind = e.target.getAttribute("data-kind");
                    searchEvents();
                    reset.style.display = "flex";

                    // Close and update the dropdown
                    dropdownKind.querySelector("[data-selected-kind]").textContent = e.target.textContent;
                    dropdownKind.dispatchEvent(new MouseEvent("mouseup"));
                });
            }
        }

        // * C) Event search by city
        let cityFilters = document.querySelectorAll("[data-city]");
        if (cityFilters.length > 0) {
            for (let currentCity of cityFilters) {
                currentCity.addEventListener("click", (e) => {
                    e.preventDefault();
                    cityId = e.target.getAttribute("data-city");
                    searchEvents();
                    reset.style.display = "flex";

                    // Close and update the dropdown
                    dropdownCity.querySelector("[data-selected-city]").textContent = e.target.textContent;
                    dropdownCity.dispatchEvent(new MouseEvent("mouseup"));
                });
            }
        }
    }
};
